var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1442_3145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.38 8.57L19.15 10.42C19.7432 11.6031 20.0336 12.9148 19.9952 14.2377C19.9568 15.5606 19.5908 16.8533 18.93 18H5.06999C4.21116 16.5101 3.85528 14.7831 4.05513 13.0751C4.25497 11.367 4.9999 9.76882 6.17947 8.51743C7.35904 7.26603 8.91046 6.42804 10.6037 6.1277C12.297 5.82735 14.042 6.08063 15.58 6.85L17.43 5.62C15.5465 4.41222 13.3123 3.871 11.0849 4.08294C8.85744 4.29487 6.76543 5.2477 5.14348 6.78901C3.52153 8.33033 2.46335 10.3711 2.13821 12.5848C1.81306 14.7986 2.23974 17.0574 3.34999 19C3.5245 19.3023 3.77508 19.5536 4.07682 19.7291C4.37856 19.9045 4.72096 19.9979 5.06999 20H18.92C19.2724 20.0014 19.6189 19.9096 19.9245 19.734C20.2301 19.5584 20.4838 19.3052 20.66 19C21.5814 17.4039 22.0438 15.5843 21.9961 13.742C21.9485 11.8996 21.3926 10.1063 20.39 8.56L20.38 8.57Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.59 15.41C10.7757 15.5959 10.9963 15.7435 11.2391 15.8441C11.4819 15.9448 11.7422 15.9966 12.005 15.9966C12.2678 15.9966 12.5281 15.9448 12.7709 15.8441C13.0137 15.7435 13.2342 15.5959 13.42 15.41L19.08 6.91998L10.59 12.58C10.404 12.7657 10.2565 12.9863 10.1559 13.2291C10.0552 13.4719 10.0034 13.7322 10.0034 13.995C10.0034 14.2578 10.0552 14.5181 10.1559 14.7609C10.2565 15.0037 10.404 15.2242 10.59 15.41Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1442_3145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d481edb799777770f7f6d0f496e40d1a.svg";
export { ForwardRef as ReactComponent };